// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".expandable-title{align-items:center;display:flex;width:100%}.roles-table{table-layout:fixed}.roles-table i{font-size:1.3rem!important}.roles-table th>span{white-space:nowrap}.roles-table .v-input__slot{align-items:center;display:flex;justify-content:center}.table-footer{display:flex;justify-content:flex-end;margin-top:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
